import React from 'react'
import styled from 'styled-components'
import { IconButton } from 'components/Button/IconButton'
import { ReactComponent as BasePlusIcon } from 'icons/plus-16.svg'

interface ButtonContainerProps {
  onClick: () => void
}

const ButtonContainer = styled(IconButton)<ButtonContainerProps>`
  width: 1.5rem;
  height: 1.5rem;
  flex: 1 0 auto;
  max-width: 1.5rem;
  padding: 0;
  justify-content: center;
  color: ${({ theme }) => theme.colors.gray};
  background-color: ${({ theme }) => theme.colors.background.light.base};
`

const PlusIcon = styled(BasePlusIcon).attrs({
  role: 'img',
})`
  width: 16px;
  height: 16px;
`

const AddMoreButton = ({ onClick, ...props }: AddMoreButtonProps) => (
  <ButtonContainer onClick={onClick} {...props}>
    <PlusIcon />
  </ButtonContainer>
)
interface AddMoreButtonProps {
  onClick: () => void
}
export default AddMoreButton
